import IllustratedMessage from '@apigrowfinance/pbolt-illustrated-message';
import { RiCloudOffLine } from 'react-icons/ri';

import loadingErrorMessages from '@messages/loadingError';
import getEnumTranslation from '@utils/getEnumTranslation';

const LoadingErrorMessage = () => (
    <IllustratedMessage
        icon={<RiCloudOffLine />}
        messageMain={getEnumTranslation('TITLE', {
            messages: loadingErrorMessages,
        })}
        messageSub={getEnumTranslation('DESCRIPTION', {
            messages: loadingErrorMessages,
        })}
    />
);

export default LoadingErrorMessage;
